import { render } from "./TheAbout.vue?vue&type=template&id=7023883a&scoped=true"
import script from "./TheAbout.vue?vue&type=script&lang=js"
export * from "./TheAbout.vue?vue&type=script&lang=js"

import "./TheAbout.vue?vue&type=style&index=0&id=7023883a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@5.6.2__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7023883a"]])

export default __exports__